/**
 * @deprecated
 * @param {unknown[]} _args
 */
export function log(..._args) {
	return;
}

/**
 * @deprecated
 * @param {unknown[]} _args
 */
export function fayeLog(..._args) {
	return;
}
